var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 13.5a1 1 0 011-1h6a1 1 0 011 1v1h3a1 1 0 110 2v13a3 3 0 01-3 3h-8a3 3 0 01-3-3v-13a1 1 0 110-2h3v-1zm3 6a1 1 0 10-2 0v8a1 1 0 102 0v-8zm4 0a1 1 0 10-2 0v8a1 1 0 102 0v-8z",
    fill: "var(--iconColorPrimary, #235CEE)"
  })));
}
export default SvgDelete;